<template>
  <PricesListCard :show-all-href="showAllHref">
    <a
      v-for="(item, index) in items"
      :key="item.translit"
      class="lpu-prices-ranges d-flex text-decoration-none rounded-20"
      :class="[
        isMobile ? 'flex-column ga-3 pa-4' : 'align-center ga-8 px-4 py-3',
        { 'bg-gray-40': index % 2 === 1 },
      ]"
      :href="`${pricesPath}#${item.translit}`"
    >
      <div class="lpu-prices-ranges__name text-body-1 text--text min-w-0">
        {{ tDynamic(item, 'name') || item.name }}
      </div>
      <div
        class="text-subtitle-1 text--text flex-shrink-0"
        :class="{ 'text-right': !isMobile }"
      >
        {{ formatRange(item.min, item.max) }}
      </div>
    </a>
  </PricesListCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import formatPrice from 'src/functions/formatPrice'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import PricesListCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesListCard.vue'
import type { PriceRange } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/types'

defineProps<{
  items: PriceRange[]
  pricesPath: string
  showAllHref?: string
}>()

const isMobile = useIsMobile()
const { context }: CommonContextStore = useContextStore()
const currency = computed(() => context.currency.symbol)

function formatRange(min?: number | string | null, max?: number | string | null) {
  const minLabel = formatPrice({ price: min, currencySymbol: currency.value })

  if (isMobile.value) {
    return `${tStatic('от')} ${minLabel}`
  }

  const maxLabel = formatPrice({ price: max, currencySymbol: currency.value })

  return `${minLabel} — ${maxLabel}`
}
</script>

<style scoped lang="scss">
@import 'src/styles/variables';

.lpu-prices-ranges {
  color: inherit;

  &:hover {
    background-color: $ui-kit-bg-gray-40;
  }

  &__name {
    word-break: break-word;
  }
}
</style>
